'use client';

import CommonAlert from 'corgi/common-alert/components/CommonAlert';
import CommonUspTeaser from 'corgi/common-usp-teaser/components/CommonUspTeaser';
import { PageGrid, PageGridItem } from 'corgi/common/components/PageGrid';
import ReclamationDrawer from 'corgi/reclamation-drawer/components/ReclamationDrawer';
import ReclamationRecapCardList from 'corgi/reclamation-recap-card-list/components/ReclamationRecapCardList';
import ReclamationRecapOrderOverview from 'corgi/reclamation-recap-order-overview/components/ReclamationRecapOrderOverview';
import SectionHeader from 'corgi/section-header/components/SectionHeader';
import ThirdPartyBanner from 'corgi/third-party-banner/components/ThirdPartyBanner';

import type { ReclamationRecapProps } from '@local-types/myaccount/page';
import { arePropsNonEmpty } from '@utils/render';

const GridItemMarginY = ['sp_4', 'sp_16', 'sp_20', 'sp_24'];

const ReclamationRecapBody = ({
  sectionHeaderProps,
  thirdPartyBannerProps,
  cardListProps,
  orderOverviewProps,
  reclamationDrawerProps,
  uspTeaserProps,
}: ReclamationRecapProps) => (
  <>
    <ReclamationDrawer {...reclamationDrawerProps} />

    <PageGrid
      display="grid"
      gridTemplateColumns={['minmax(312px, 1fr)', 'minmax(616px, 1fr)', '1fr 380px', '1fr 432px']}
      alignItems="stretch"
      width={1}
      maxWidth={1600}
      py={['sp_0', 'sp_8', null, 'sp_16']}
      px={['sp_4', 'sp_16', 'sp_48', 'sp_64']}
    >
      <PageGrid
        flex={1}
        margin={'sp_0'}
        mb={['sp_16', 'sp_20', 'sp_24', 'sp_32']}
        flexDirection="column"
        alignItems="stretch"
      >
        <SectionHeader headingAs="h1" {...sectionHeaderProps} />
        <PageGridItem mt="sp_16">
          <CommonAlert mb="sp_16" />
          <ReclamationRecapCardList {...cardListProps} />
        </PageGridItem>
      </PageGrid>
      <PageGridItem
        ml={['sp_0', null, 'sp_24', 'sp_32']}
        mt={['sp_0', null, '44px']}
        mb={['sp_4', null, 'sp_24', 'sp_32']}
      >
        <ReclamationRecapOrderOverview {...orderOverviewProps} />
        {arePropsNonEmpty(thirdPartyBannerProps) && (
          <PageGridItem mt={['sp_8', 'sp_24', 'sp_12', 'sp_16']}>
            <ThirdPartyBanner {...thirdPartyBannerProps} />
          </PageGridItem>
        )}
      </PageGridItem>
    </PageGrid>

    {arePropsNonEmpty(uspTeaserProps) && (
      <PageGridItem width={1} mt={GridItemMarginY}>
        <CommonUspTeaser {...uspTeaserProps} />
      </PageGridItem>
    )}
  </>
);

export default ReclamationRecapBody;
